<template>
	<button class="btn btn-icon-text">
		<svgicon :name="icon" :fill="false"></svgicon>
		<span>
			<slot/>
		</span>
	</button>
</template>

<script>
export default {
	props: [
		'icon'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonNativeIconText.vue